(() => {
  const saved = new WeakMap();
  let approvedNavigation = false;
  const fields = node => [...node.querySelectorAll('[data-sample-field]')];
  const snapshot = node => JSON.stringify(fields(node).map(f => f.value));
  const dirty = node => fields(node).some(f => f.value.trim()) && snapshot(node) !== saved.get(node);
  const dirtySample = () => [...document.querySelectorAll('kana-sample')].find(dirty);
  document.addEventListener('click', event => {
    const exporter = event.target.closest('[data-sample-export]');
    if (exporter) {
      const node = exporter.closest('kana-sample');
      const title = node.querySelector('h2').textContent;
      const text = title + '\n\n' + fields(node).map(field => {
        const label = document.querySelector('label[for="' + field.id + '"]');
        return (label?.textContent.trim() || '') + '\n' + field.value;
      }).join('\n\n');
      const url = URL.createObjectURL(new Blob([text], { type: 'text/plain;charset=utf-8' }));
      const link = document.createElement('a'); link.href = url; link.download = 'Kana-Digital-meine-Journalseite.txt';
      document.body.append(link); link.click(); link.remove(); setTimeout(() => URL.revokeObjectURL(url), 1000);
      saved.set(node, snapshot(node)); node.querySelector('[data-sample-status]').textContent = node.dataset.exported;
      return;
    }
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || link.target === '_blank') return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname === location.pathname && url.search === location.search && url.hash) return;
    if (!/^https?:$/.test(url.protocol)) return;
    const node = dirtySample();
    if (node) {
      if (!window.confirm(node.dataset.leave)) { event.preventDefault(); event.stopImmediatePropagation(); }
      else { approvedNavigation = true; setTimeout(() => { approvedNavigation = false; }, 1000); }
    }
  }, true);
  window.addEventListener('beforeunload', event => {
    if (approvedNavigation || !dirtySample()) return;
    event.preventDefault(); event.returnValue = '';
  });
  const allowedKinds = new Set(['journal','fitness','habit','books','business','travel','budget','bundle','business_bundle','complete_bundle']);
  const send = (name, element) => {
    const kind = element.closest('[data-trial-kind],[data-product-kind]')?.dataset;
    const value = kind?.trialKind || kind?.productKind;
    const shopify = window.Shopify;
    if (!allowedKinds.has(value) || !shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    if (shopify.customerPrivacy.currentVisitorConsent?.().analytics !== 'yes') return;
    if (typeof shopify.analytics?.publish !== 'function') return;
    shopify.analytics.publish('kana:' + name, { journal_kind: value });
  };
  document.addEventListener('click', event => {
    const target = event.target.closest('[data-sample-export],[data-gallery-open],.kana-trial-hero-actions .button,.kana-sample-full-link .button');
    if (!target) return;
    const name = target.hasAttribute('data-sample-export') ? 'trial_exported' : target.hasAttribute('data-gallery-open') ? 'gallery_opened' : target.closest('.kana-sample-full-link') ? 'full_version_clicked' : 'trial_action_clicked';
    send(name, target);
  });
  const started = new WeakSet();
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-sample-field]')) return;
    const node = event.target.closest('kana-sample');
    if (started.has(node)) return;
    started.add(node); send('trial_started', node);
  });
  document.querySelectorAll('[data-trial-kind]').forEach(node => send('trial_viewed', node));
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.matches('.kana-impulse-product form')) return;
    if (!form.matches('.product-info form, .kana-journal-form') || form.dataset.kanaSubmitting === 'yes') return;
    const variant = new FormData(form).get('id');
    if (!variant) return;
    event.preventDefault();
    if (form.dataset.kanaChecking === 'yes') return;
    form.dataset.kanaChecking = 'yes';
    const submitter = event.submitter;
    const originalLabel = submitter?.textContent;
    form.setAttribute('aria-busy', 'true');
    if (submitter) { submitter.setAttribute('aria-disabled', 'true'); submitter.textContent = document.body.dataset.kanaAdding || originalLabel; }
    const checkAbort = new AbortController();
    const checkTimer = setTimeout(() => checkAbort.abort(), 7000);
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', { signal: checkAbort.signal, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (response.ok) {
        const cart = await response.json();
        if (cart.items.some(item => String(item.variant_id) === String(variant))) { location.assign(root + 'cart'); return; }
      }
    } catch (_) {}
    finally { clearTimeout(checkTimer); delete form.dataset.kanaChecking; }
    form.dataset.kanaSubmitting = 'yes';
    if (submitter) { submitter.removeAttribute('aria-disabled'); submitter.textContent = originalLabel; }
    form.removeAttribute('aria-busy');
    form.requestSubmit(submitter || undefined);
  });
  if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
})();


(() => {
  const prepareDemos = root => {
    const videos = [...root.querySelectorAll('.kana-demo-video')];
    if (root.matches?.('.kana-demo-video')) videos.unshift(root);
    videos.forEach(video => {
      if (video.dataset.kanaFastDemo === 'ready') return;
      video.defaultPlaybackRate = 1;
      video.playbackRate = 1;
      video.dataset.kanaFastDemo = 'ready';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepareDemos(document), { once: true });
  else prepareDemos(document);
  document.addEventListener('shopify:section:load', event => prepareDemos(event.target));
})();

